export default function BusinessTeamIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_84571_84902)'>
        <mask
          id='mask0_84571_84902'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='24'
          height='24'
        >
          <rect width='24' height='24' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_84571_84902)'>
          <path
            d='M12 13.7692C12.4858 13.7692 12.899 13.5991 13.2395 13.2587C13.5798 12.9183 13.75 12.5051 13.75 12.0192C13.75 11.5334 13.5798 11.1202 13.2395 10.7797C12.899 10.4394 12.4858 10.2693 12 10.2693C11.5142 10.2693 11.101 10.4394 10.7605 10.7797C10.4202 11.1202 10.25 11.5334 10.25 12.0192C10.25 12.5051 10.4202 12.9183 10.7605 13.2587C11.101 13.5991 11.5142 13.7692 12 13.7692ZM8.25 17.4615H15.75V17.098C15.75 16.7428 15.6545 16.4275 15.4635 16.152C15.2725 15.8763 15.0109 15.6648 14.6788 15.5173C14.2648 15.3404 13.835 15.2036 13.3895 15.1067C12.944 15.0099 12.4808 14.9615 12 14.9615C11.5192 14.9615 11.056 15.0099 10.6105 15.1067C10.165 15.2036 9.73525 15.3404 9.32125 15.5173C8.98908 15.6648 8.7275 15.8763 8.5365 16.152C8.3455 16.4275 8.25 16.7428 8.25 17.098V17.4615ZM17.6923 21.5H6.30775C5.80258 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V4.30775C4.5 3.80258 4.675 3.375 5.025 3.025C5.375 2.675 5.80258 2.5 6.30775 2.5H13.7885L19.5 8.2115V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6923 21.5ZM17.6923 20C17.7692 20 17.8398 19.9679 17.9038 19.9038C17.9679 19.8398 18 19.7693 18 19.6923V8.85L13.15 4H6.30775C6.23075 4 6.16025 4.03208 6.09625 4.09625C6.03208 4.16025 6 4.23075 6 4.30775V19.6923C6 19.7693 6.03208 19.8398 6.09625 19.9038C6.16025 19.9679 6.23075 20 6.30775 20H17.6923Z'
            fill='currentColor'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_84571_84902'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
